import { render, staticRenderFns } from "./searchHuov.vue?vue&type=template&id=53c4306a&scoped=true"
import script from "./searchHuov.vue?vue&type=script&lang=js"
export * from "./searchHuov.vue?vue&type=script&lang=js"
import style0 from "./searchHuov.vue?vue&type=style&index=0&id=53c4306a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c4306a",
  null
  
)

export default component.exports